<script lang="ts">
    import { onMount } from 'svelte'
    import Fa from 'svelte-fa'
    import { faCopy } from '@fortawesome/free-solid-svg-icons'
    import type { Profile } from '../../modules/toolsApi/sites/profiles/profile'
    import type { Schedule } from '../../modules/schedulerApi/schedules/schedule'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../_common/z/zgrid'
    import Zgrid from '../_common/z/zgrid.svelte'

    export let personId: string

    let loaded = false
    onMount(async () => {
        await loadLink()
        loaded = true
    })

    let links: { label: String; url: string; active: boolean }[] = []
    let profile: Profile = null
    async function loadLink() {
        links = []
        let url = ''
        profile = await window.api.tools.sites.profiles.getOne(window.store.company.companyId)
        if (profile?.slug) {
            const token = await getPersonToken()
            if (!token) {
                window.error('Link indisponível')
                return
            }
            if (location.href.includes('127.0.0') || location.href.includes('localhost')) {
                url = 'http://localhost:5173/login?p=' + personId + '&t=' + token
            } else {
                url = 'https://agenda.zandu.com.br/login?p=' + personId + '&t=' + token
            }
            links.push({
                label: 'Link',
                url: url,
                active: true,
            })
            links = links
            loadGrid()
        }
    }

    async function getPersonToken() {
        const response = await window.api.events.persons.LoginByLink(personId)
        console.log('resp', response)
        if (!response) return null
        return response.linkToken
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Link para agendamento online'
        grid.subtitle = 'Copie o link abaixo e envie ao cliente'
        grid.showActs = false
        grid.cols.push(new GridCol({ content: 'Link' }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of links) {
            const btnCopy = new GridButton({
                callback: () => copyLink(item.url),
                icon: faCopy,
                label: 'Copiar',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.url })
            if (item.active) {
                line.slots.push({ content: [btnCopy] })
            } else {
                line.slots.push({ content: [] })
            }
            grid.lines.push(line)
        }
    }

    function copyLink(url) {
        window.api.utils.utils.copyToClipboard(url)
        window.alert('Link copiado')
    }
</script>

{#if loaded}
    <div class="root m-3">
        {#if !profile}
            <div class="config-box text-center">
                Você ainda não configurou seu aplicativo.<br />
                Para configurar acesse o menu 'Ferramentas &gt; Meu Aplicativo'
            </div>
        {:else}
            <Zgrid {grid} />
            <div class="config-box mt-2 text-muted">
                Permita que seu cliente agende o próprio horário mas mantenha o controle de sua agenda.<br />
                Para configurar as regras de agendamento acesse FERRAMENTAS &gt; MEU APLICATIVO.<br />
                Caso haja um intervalo obrigatório entre sessões configure o serviço em FERRAMENTAS &gt; SERVIÇOS.
            </div>
        {/if}
    </div>
{/if}

<style>
</style>
